import { render, staticRenderFns } from "./DollarSign.vue?vue&type=template&id=35e388a2&scoped=true"
import script from "./DollarSign.vue?vue&type=script&lang=js"
export * from "./DollarSign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e388a2",
  null
  
)

export default component.exports